import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Im Produktions-Build (STRATO) wird REACT_APP_API_BASE=/api gesetzt → gleiche Domain.
// In der Vorschau ist die Variable nicht gesetzt → Fallback auf die Vorschau-URL.
export const API = process.env.REACT_APP_API_BASE || `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mfmed_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
